import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialCommercialCartSelection, initialShoppingCart } from './shopping_cart.initial';
import { getSuggestedCalc } from './thunks';

export const shoppingCartSlice = createSlice({
    name: 'shopping_cart',
    initialState: initialShoppingCart,
    reducers: {
        setSuggestions: (state, action) => {
            state.suggested = action.payload;
        },
        toggleProductSelection: (
            state,
            action: PayloadAction<{
                productId: number;
                willBeSelected: boolean;
                productIdsToClear: number[];
                initialQuantity?: number;
                initialPrice?: number;
            }>
        ) => {
            const { productId, willBeSelected, productIdsToClear, initialQuantity = 1, initialPrice = 1 } = action.payload;
            const sel = state.suggested.selection;
            const nextSelected = { ...sel.selectedByProductId, [productId]: willBeSelected };
            productIdsToClear.forEach((id) => delete nextSelected[id]);
            state.suggested.selection.selectedByProductId = nextSelected;

            const nextQ = willBeSelected ? { ...sel.quantityByProductId, [productId]: initialQuantity } : { ...sel.quantityByProductId };
            if (!willBeSelected) delete nextQ[productId];
            productIdsToClear.forEach((id) => delete nextQ[id]);
            state.suggested.selection.quantityByProductId = nextQ;

            const nextP = willBeSelected ? { ...sel.priceByProductId, [productId]: initialPrice } : { ...sel.priceByProductId };
            if (!willBeSelected) delete nextP[productId];
            productIdsToClear.forEach((id) => delete nextP[id]);
            state.suggested.selection.priceByProductId = nextP;

            // Limpiar errores del producto deseleccionado y de los limpiados
            const nextE = { ...sel.inputErrorByProductId };
            if (!willBeSelected) delete nextE[productId];
            productIdsToClear.forEach((id) => delete nextE[id]);
            state.suggested.selection.inputErrorByProductId = nextE;
        },
        setInputError: (
            state,
            action: PayloadAction<{ productId: number; field: 'price' | 'quantity'; hasError: boolean }>
        ) => {
            const { productId, field, hasError } = action.payload;
            const current = state.suggested.selection.inputErrorByProductId[productId] ?? { price: false, quantity: false };
            state.suggested.selection.inputErrorByProductId[productId] = { ...current, [field]: hasError };
        },
        setSelectionQuantity: (state, action: PayloadAction<{ productId: number; value: number }>) => {
            const { productId, value } = action.payload;
            state.suggested.selection.quantityByProductId[productId] = value;
        },
        setSelectionPrice: (state, action: PayloadAction<{ productId: number; value: number }>) => {
            const { productId, value } = action.payload;
            state.suggested.selection.priceByProductId[productId] = value;
        },
        setSelectedMonths: (state, action: PayloadAction<number | null>) => {
            state.suggested.selection.selectedMonths = action.payload;
            const months = action.payload;
            if (months !== 3 && months !== 6) {
                const premiumProductIds = (state.suggested.products.category.premium ?? []).map((p) => p.product_id);
                const sel = state.suggested.selection;
                premiumProductIds.forEach((id) => {
                    delete sel.selectedByProductId[id];
                    delete sel.quantityByProductId[id];
                    delete sel.priceByProductId[id];
                    delete sel.inputErrorByProductId[id];
                });
            }
        },
        setSelectedPaymentMethod: (state, action: PayloadAction<number | null>) => {
            state.suggested.selection.selectedPaymentMethod = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getSuggestedCalc.pending,(state, action) => {
                state.suggested.users.user_id = 0;
                state.loading = true;
                state.error = false;
            }
        );
        builder.addCase(getSuggestedCalc.fulfilled,(state, action) => {
                state.loading = false;
                if(!action.payload.success){
                    state.error = true;
                    state.errorMessage = action.payload.message;
                    state.suggested = initialShoppingCart.suggested;
                }else{
                    console.log(action.payload);
                    state.errorMessage = '';
                    state.error = false;
                    state.suggested = { ...action.payload, selection: initialCommercialCartSelection };
                }
            }
        );
        builder.addCase(getSuggestedCalc.rejected, (state) => {
            state.loading = false;
            state.error = true;
        });
    },
});

export const {
    setSuggestions,
    toggleProductSelection,
    setSelectionQuantity,
    setSelectionPrice,
    setSelectedMonths,
    setSelectedPaymentMethod,
    setInputError,
} = shoppingCartSlice.actions;

export default shoppingCartSlice.reducer;
